module.exports = __webpack_public_path__ + "static/media/felfel dolme.3ce18950.png";